import { z } from 'zod';
import type { OrderStateToken } from '@sleed/bizcommerce-api';

/**
 * Order state (Εσωτερική Κατάσταση) edit form. Mirrors `OrderStateToken` and the legacy admin grid
 * (Core/client/admin/src/pages/Orders/OrderStates/index.js): cd optional ≤50, nm required ≤100,
 * erpcd optional ≤50, iv boolean, si required. There is no ML sub-token — the name is stored at the
 * top level (parity with PriceTypes/RelationTypes via the Accept-Language=el pin).
 */
export const orderStateSchema = z.object({
	id: z.number().optional(),
	cd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	nm: z.string().trim().min(1, 'validation.required').max(100, 'validation.tooLong'),
	erpcd: z.string().trim().max(50, 'validation.tooLong').nullable(),
	iv: z.boolean(),
	si: z.number({ message: 'validation.required' }).int()
});

export type OrderStateFormValues = z.infer<typeof orderStateSchema>;

export const EMPTY_ORDER_STATE: OrderStateFormValues = {
	cd: '',
	nm: '',
	erpcd: '',
	iv: true,
	si: 0
};

export function tokenToForm(token: OrderStateToken): OrderStateFormValues {
	return {
		id: token.id,
		cd: token.cd ?? '',
		nm: token.nm ?? '',
		erpcd: token.erpcd ?? '',
		iv: token.iv ?? false,
		si: token.si ?? 0
	};
}

export function formToToken(form: OrderStateFormValues): OrderStateToken {
	return {
		id: form.id,
		cd: form.cd?.trim() || null,
		nm: form.nm.trim(),
		erpcd: form.erpcd?.trim() || null,
		iv: form.iv,
		si: form.si
	};
}
